import axios, { AxiosResponse } from "axios";
import { ApiError } from "../ApiError";
import apis from "../apis";
import { NodeIdSpaceId } from "./SpaceRepository";

export class DisableSpacesEndpoint implements IDisableSpacesEndpoint
{
    public async execute(nodeId: number, spaces: NodeIdSpaceId[]): Promise<void>
    {
        try
        {
            await axios.patch<void>(`${apis.allApiv2}${nodeId}/Spaces/disable`, spaces);
        }
        catch (response)
        {
            throw ApiError.fromAxiosResponse(response as AxiosResponse);
        }
    }
}

export interface IDisableSpacesEndpoint
{
    execute(nodeId: number, spaces: NodeIdSpaceId[]): Promise<void>;
}
